<div class="wrapper">
  <a [routerLink]="'/showcase'">Showcases</a>
  <a [routerLink]="'/help'">Viewer help</a>
  <a [routerLink]="'/hyperscene'">Hyperscene 2.0 (&#64;sibe/hyperscene)</a>
  <a [routerLink]="'/500 000 items'">500 000 items</a>
  <a [routerLink]="'/unique-objects'">Unique objects</a>
  <a [routerLink]="'/user-actions'">User actions</a>
  <a [routerLink]="'/camera-tools'">Camera Tools</a>
  <a [routerLink]="'/indexed-mesh-object'">Indexed mesh object</a>
  <a [routerLink]="'/standard-geometric-objects'">Standard geometric objects</a>
  <a [routerLink]="'/lights'">Lights</a>
  <a [routerLink]="'/textured-geometric-objects'">Textured geometric objects</a>
  <a [routerLink]="'/lines'">Lines</a>
  <a [routerLink]="'/points'">Points</a>
  <a [routerLink]="'/all-objects'">All Objects</a>
  <a [routerLink]="'/layers'">Layers</a>
  <a [routerLink]="'/sprite-objects'">Sprite objects</a>
  <a [routerLink]="'/raycast'">Raycast</a>
  <a [routerLink]="'/custom-shaders'">Custom shaders</a>
  <a [routerLink]="'/ui-tools'">UI Tools</a>
  <a [routerLink]="'/clipping-planes'">Clipping planes</a>
  <a [routerLink]="'/layer-position'">Layer position</a>
  <a [routerLink]="'/composite-materials'">Composite materials</a>
</div>
